import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_BASE_URL;

// ================= FETCH PLANS =================
export const fetchPlans = createAsyncThunk(
  "plans/fetchPlans",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/plans`);
      return res.data.plans;
    } catch (err) {
      return rejectWithValue("Failed to load plans");
    }
  }
);

const planSlice = createSlice({
  name: "plans",
  initialState: {
    plans: [],
    loading: false,
    error: null,
    selectedPlan: null,
  },

  reducers: {
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },

    clearPlans: (state) => {
      state.plans = [];
      state.selectedPlan = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedPlan, clearPlans } = planSlice.actions;
export default planSlice.reducer;